module.exports = __webpack_public_path__ + "img/pv_today_gen.f20a5e6a.svg";